import type { PlcManufacturerCodeLibrary } from "./types";

export const panasonicCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "panasonic",
  manufacturer_name: "Panasonic Industry",
  codes: [
    {
      id: "panasonic-fp0r-watchdog",
      manufacturer_id: "panasonic",
      series_id: "panasonic-fp0r",
      model: null,
      code: "WATCHDOG TIMER",
      code_type: "Self-diagnostic",
      title_ar: "FP0R Watchdog diagnostic",
      description_ar: "FP0R يتضمن Self-diagnostic للـWatchdog Timer بحدود تقريبية مذكورة من المصنع.",
      symptoms: ["الـPLC ممكن يتوقف إذا دورة التنفيذ ما تكمل بصورة طبيعية", "حالة watchdog بالتشخيص"],
      causes: ["برنامج عالق أو زمن تنفيذ غير طبيعي", "خلل داخلي"],
      checks: [
        {
          step: 1,
          action: "راجع البرنامج ووقت الـscan قبل تغيير أي إعداد.",
          expected: "البرنامج يكمل ضمن الزمن الطبيعي.",
          faulty: "تنفيذ البرنامج يتجاوز حدود المراقبة أو يعلق.",
        }
      ],
      solutions: ["عالج loops أو منطق يسبب تعليق.", "إذا استمر بدون سبب برمجي واضح، افحص الـCPU."],
      severity: "حرجة",
      source_title: "Panasonic Industry FP0R Programmable Controller",
      source_section: "Self-diagnostic function: Watchdog timer",
      keywords: ["Panasonic", "FP0R", "watchdog", "self diagnostic"],
    },
    {
      id: "panasonic-fp0r-syntax",
      manufacturer_id: "panasonic",
      series_id: "panasonic-fp0r",
      model: null,
      code: "PROGRAM SYNTAX CHECK",
      code_type: "Self-diagnostic",
      title_ar: "FP0R Program Syntax Check",
      description_ar: "FP0R يتضمن فحص ذاتي لصحة صياغة البرنامج.",
      symptoms: ["البرنامج ما يشتغل بالصورة المتوقعة", "يظهر تشخيص مرتبط بالبرنامج"],
      causes: ["خطأ بصياغة أو بناء البرنامج"],
      checks: [
        {
          step: 1,
          action: "اعمل Compile/Check من Control FPWIN المناسب.",
          expected: "المشروع يمر بدون syntax errors.",
          faulty: "البرنامج يحتوي خطأ يمنع التنفيذ الصحيح.",
        }
      ],
      solutions: ["صحح الخطأ بالبرنامج ثم أعد التحقق.", "لا تنزل مشروع غير متحقق للمعدة."],
      severity: "عالية",
      source_title: "Panasonic Industry FP0R Programmable Controller",
      source_section: "Self-diagnostic function: Program syntax check",
      keywords: ["Panasonic", "FP0R", "syntax check"],
    },  ],
};
